"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _rumEvent = require("../types/rum-event");
var _exception = require("../utils/exception");
var _is = require("../utils/is");
var FLUSH_TIME = 3000;
var MAX_EVENT_COUNT = 20;
var Reporter = exports["default"] = /*#__PURE__*/function () {
  function Reporter() {
    this.name = 'reporter';
    /**
     * 新上报事件优先检测队列是否超过 50 条，如果超过立即 report。
     * 如果没超过则检测 FlushTime 内有无新上报事件，如果有新事件，重置 timer，无则 report
     */
    this.eventQueue = [];
    this.ctx = void 0;
    this.timer = void 0;
  }
  var _proto = Reporter.prototype;
  _proto.getReportCfg = function getReportCfg() {
    var cfg = this.ctx.getConfig().reportConfig;
    if (!(0, _is.isObject)(cfg)) {
      cfg = {};
    }
    if (!cfg.flushTime || cfg.flushTime < 0 || cfg.flushTime > 10000) {
      cfg.flushTime = FLUSH_TIME;
    }
    if (!cfg.maxEventCount || cfg.maxEventCount < 1 || cfg.maxEventCount > 100) {
      cfg.maxEventCount = MAX_EVENT_COUNT;
    }
    return cfg;
  };
  _proto.report = function report(ctx) {
    var _this = this;
    this.ctx = ctx;
    this.init(ctx);
    clearTimeout(this.timer);
    this.pushToQueue();
    var reportConfig = this.getReportCfg();
    // 超过 MaxCount 直接 flush，否则延迟发送
    if (this.eventQueue.length >= reportConfig.maxEventCount) {
      this.flushEventQueue();
    } else {
      this.timer = setTimeout(function () {
        _this.flushEventQueue();
      }, reportConfig.flushTime);
    }
  };
  _proto.pushToQueue = function pushToQueue() {
    var ctx = this.ctx,
      eventQueue = this.eventQueue;
    var event = ctx.getRumEvent();

    // 针对相同 event，做 times 合并
    // todo，支持其他类型 event 合并
    if (event.event_type === _rumEvent.RumEventType.EXCEPTION) {
      var _ref = event,
        message = _ref.message,
        stack = _ref.stack;
      var curErrorId = (0, _exception.getErrorID)({
        message: message,
        stack: stack
      });
      var targetEvent = this.eventQueue.find(function (cacheEvent) {
        if (cacheEvent.event_type === _rumEvent.RumEventType.EXCEPTION) {
          var _ref2 = cacheEvent,
            _message = _ref2.message,
            _stack = _ref2.stack;
          return (0, _exception.getErrorID)({
            message: _message,
            stack: _stack
          }) === curErrorId;
        }
      });
      if (targetEvent) {
        targetEvent.times++;
        return;
      }
    }
    if (event.event_type === _rumEvent.RumEventType.ACTION) {
      var _ref3 = event,
        target_name = _ref3.target_name;
      var _targetEvent = this.eventQueue.find(function (cacheEvent) {
        if (cacheEvent.event_type === _rumEvent.RumEventType.ACTION) {
          return target_name === cacheEvent.target_name;
        }
      });
      if (_targetEvent) {
        _targetEvent.times++;
        return;
      }
    }
    eventQueue.push(event);
  }

  /**
   * eventQueue 提取最新 View 作为公共 View，event 中不同 View Event 保留 View id
   */;
  _proto.flushEventQueue = function flushEventQueue() {
    var ctx = this.ctx,
      eventQueue = this.eventQueue;
    if (!eventQueue.length) {
      return;
    }
    var views = ctx.getViews();
    var curView = views[views.length - 1];
    views.forEach(function (view) {
      if (view.id === curView.id) {
        var _events = eventQueue.filter(function (event) {
          var _event$view;
          return ((_event$view = event.view) === null || _event$view === void 0 ? void 0 : _event$view.id) === view.id;
        });
        _events.forEach(function (event) {
          delete event.view;
        });
      }
    });
    var session = ctx.session;
    var sampled = session ? session.getSampled() : true;
    sampled && this.request(ctx, eventQueue, curView);
    this.eventQueue = [];
  }

  /**
   * 接口请求由各平台 sdk reporter 实现
   */;
  /**
   * 初始化时
   */
  _proto.init = function init(ctx) {};
  return Reporter;
}();